import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDeleteTool = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 22,
	viewBox: "0 0 20 22",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "none",
		fillRule: "evenodd",
		stroke: "#4A5666",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		children: /* @__PURE__ */ _jsx("path", { d: "M3 7h14l-.9 12.607A1.5 1.5 0 0 1 14.603 21H5.397A1.5 1.5 0 0 1 3.9 19.607zM12.5 11l-.5 6M7.5 11l.5 6M2.504 3C1.673 3 1 3.672 1 4.5v1C1 6.326 1.673 7 2.504 7h14.992C18.327 7 19 6.328 19 5.5v-1c0-.826-.673-1.5-1.504-1.5L13.5 2.5c0-.826-.672-1.5-1.502-1.5H8.002A1.5 1.5 0 0 0 6.5 2.5z" })
	})
});
export default SvgDeleteTool;
